<template>
  <div>
    <div v-if="product.loading">
      <Loader :loading="product.loading" />
    </div>
    <div v-else>
      <b-card bg-variant="default"
                  text-variant="black"
                  header="Upplýsingar"
                  class="text-left">
        <b-row>
            <b-col>Lýsing</b-col>
            <b-col v-html='product.title'/>
        </b-row>
        <b-row v-if='product.originalPrice'>
            <b-col>Verð án afsláttar</b-col>
            <b-col>{{product.originalPrice}} {{product.currencyCode}}</b-col>
        </b-row>
        <b-row>
            <b-col>Verð</b-col>
            <b-col>{{product.salePrice}} {{product.currencyCode}}</b-col>
        </b-row>
      </b-card>
      <div class="result-items row">
        <div v-for="res in product.images" :key="res.id" class="col-sm result-col rounded">
          <div class="thumbnail result-item">
            <b-img-lazy :src="res"
              width="200" 
              height="200" 
              blank-color="#bbb" 
              alt="img" 
              class="border mx-auto d-block" />
          </div>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader'
export default {
  name: 'detail',
  props: ['product'],
  data () {
    return {}
  },
  components: {
    'Loader': Loader
  }
}
</script>
<style lang='scss' scoped>
.result-col {
  padding: 5px;
  margin: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Detail.vue